import { render, staticRenderFns } from "./syllabusInfo.vue?vue&type=template&id=10737d48&scoped=true&"
import script from "./syllabusInfo.vue?vue&type=script&lang=js&"
export * from "./syllabusInfo.vue?vue&type=script&lang=js&"
import style0 from "./syllabusInfo.vue?vue&type=style&index=0&id=10737d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10737d48",
  null
  
)

export default component.exports